import type { FC } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface ISwiperTextProps {
  title: string;
  desciption?: string;
  viewBox?: string;
  iconSx?: SxProps<Theme>;
  boxSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  desciptionSx?: SxProps<Theme>;
  handleClick?: () => void;
}

const SwiperText: FC<ISwiperTextProps> = ({
  title,
  titleSx,
  desciption,
  desciptionSx,
  boxSx,
  handleClick,
}) => {
  const initBoxSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    gap: 1,
    alignItems: 'flex-start',
    border: '1px solid inherited',
    textAlign: 'left',
    px: 3,
  };

  const initTitleSx: SxProps<Theme> = {
    fontSize: '20px',
    fontWeight: 700,
    color: 'inherit',
    lineHeight: 'normal',
    py: 3,
  };

  const initDesciptionSx: SxProps<Theme> = {
    fontSize: '20px',
    fontWeight: 400,
    color: 'inherit',
    lineHeight: 'normal',
    pb: 3,
  };
  return (
    <Box sx={{ ...initBoxSx, ...boxSx }} onClick={handleClick}>
      <Box sx={{ ...initTitleSx, ...titleSx }}>{title}</Box>
      <Box sx={{ ...initDesciptionSx, ...desciptionSx }}>{desciption}</Box>
    </Box>
  );
};

export default SwiperText;
